import React, { useEffect } from 'react';
import styles from '../shared/TipComponents.module.scss';

/* Components */
import { ProductContainer } from '../../../shared/components/ProductContainer/ProductContainer';
import { TipHeader } from '../../components/TipHeader/TipHeader';
import { TipBox } from '../../components/TipBox/Box/TipBox';
import { TipCouponInfo } from '../../components/TipCouponInfo/TipCouponInfo';
import { LockedTipBoxTop } from '../../components/TipBox/Top/LockedTipBoxTop';
import { Product } from '../../../../PaymentGateway/interfaces/Product';
import { UnavailableTipBoxTop } from '../../components/TipBox/Top/UnavailableTipBoxTop';
import { PaymentGateway } from '../../../../PaymentGateway/PaymentGateway';

/* Interfaces */
import { PaidTipProduct, Tipster } from '../../interfaces/TipProduct';
import { StoreTypesReversed } from '../../../../PaymentGateway/interfaces/store_types';
import { TipTicket } from '../../../../../api/tips';

/* Redux */
import { RootState } from '../../../../../store';
import { connect } from 'react-redux';
import { LoginState } from '../../../../../store/login/reducer';
import { userSelector } from '../../../../../store/login/selector';

/* Assets */
import discountSticker from '../../../shared/assets/label.svg';
import SVG from 'react-inlinesvg';

/* Providers */
import { ProductContext } from '../../../../PaymentGateway/__providers__/ProductContext';
import { useShopContext } from '../../../shared/__providers__/ShopContext';

interface PaidTipProps {
  tipster: Tipster;
  tip: PaidTipProduct;
}

interface ReduxProps {
  couponsState: TipTicket[];
  user: any;
  loginState: LoginState;
}

export const PaidTipComponent: React.FC<PaidTipProps & ReduxProps> = ({
  tipster,
  tip,
  couponsState,
  user,
  loginState,
}) => {
  const hasDiscount = tip.discountPercentage > 0;
  const { shop } = useShopContext();

  const product = new Product({
    id: tip.tip.id,
    price: tip.price,
    name: tip.tip.id,
    discount: tip.priceWithDiscount,
  }).withUnlockable(tipster, tip.tip.pricing_tier_code, couponsState);

  return (
    <ProductContext.Provider value={{ product }}>
      <ProductContainer>
        <div className={styles.container}>
          {hasDiscount && !product.unlockable && (
            <div className={styles.discountSticker}>
              <SVG src={discountSticker} />
              <h3>-{tip.discountPercentage}%</h3>
            </div>
          )}
          <TipHeader type={tip.priceType} />

          <TipBox>
            {tip.checkAvailability().isAvailable ? (
              <LockedTipBoxTop />
            ) : (
              <UnavailableTipBoxTop />
            )}
          </TipBox>

          <TipCouponInfo />
        </div>
        {tip.checkAvailability().isAvailable && shop && (
          <PaymentGateway
            storeType={StoreTypesReversed.TipPurchase}
            shop={shop}
            loginState={loginState}
            tipProduct={product}
          />
        )}
      </ProductContainer>
    </ProductContext.Provider>
  );
};

const mapStateToProps = (state: RootState) => ({
  couponsState: state.tipsInfo.coupons,
  user: userSelector(state),
  loginState: state.login,
});

export const PaidTipComponentConnected =
  connect(mapStateToProps)(PaidTipComponent);
